import { useState } from 'react'
import { Image, Search, Download } from 'lucide-react'
import useStore from '../store/useStore'

export default function ImageLibrary() {
  const { images } = useStore()
  const [search, setSearch] = useState('')

  const filtered = images.filter(img =>
    img.prompt?.toLowerCase().includes(search.toLowerCase()) ||
    img.character?.toLowerCase().includes(search.toLowerCase())
  )

  return (
    <div className="flex-1 overflow-y-auto p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-bold text-white">Image Library</h2>
          <p className="text-slate-400 text-sm mt-1">{images.length} image{images.length !== 1 ? 's' : ''} generated</p>
        </div>
        <div className="relative">
          <Search size={15} className="absolute left-3 top-2.5 text-slate-400" />
          <input className="input pl-9 w-64" placeholder="Search images..." value={search}
            onChange={e => setSearch(e.target.value)} />
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="text-center py-16">
          <Image size={48} className="text-slate-600 mx-auto mb-4" />
          <h3 className="text-white font-medium mb-2">No images yet</h3>
          <p className="text-slate-400 text-sm">Generated images will appear here.</p>
        </div>
      ) : (
        <div className="grid grid-cols-4 gap-3">
          {filtered.map(img => <ImageCard key={img.id} img={img} />)}
        </div>
      )}
    </div>
  )
}

function ImageCard({ img }) {
  return (
    <div className="card overflow-hidden group">
      <div className="aspect-square bg-surface-muted relative">
        {img.url ? (
          <img src={img.url} alt={img.prompt} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Image size={24} className="text-slate-600" />
          </div>
        )}
        <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
          <a href={img.url} download className="p-2 rounded-lg bg-white/20 hover:bg-white/30 text-white">
            <Download size={16} />
          </a>
        </div>
      </div>
      <div className="p-2">
        <p className="text-xs text-slate-400 line-clamp-2">{img.prompt}</p>
        <span className="text-xs text-slate-500 mt-1 block">{img.character || 'No character'}</span>
      </div>
    </div>
  )
}
